function Marquee() {
  return (
<div className="mq" aria-hidden="true">
      <div className="mq-track">
        <span className="mq-item">Find a Job
 <span className="mq-sep">·</span></span
        ><span className="mq-item"
          >Hire Talent
 <span className="mq-sep">·</span></span
        ><span className="mq-item"
          >Explore a Program <span className="mq-sep">·</span></span
        ><span className="mq-item"
          >Onboard Your College <span className="mq-sep">·</span></span
        ><span className="mq-item"
          > <span className="mq-sep">·</span></span
        ><span className="mq-item"
          >Placement Assistance <span className="mq-sep">·</span></span
        ><span className="mq-item"
          >Find a Job
 <span className="mq-sep">·</span></span
        ><span className="mq-item"
          >Hire Talent
 <span className="mq-sep">·</span></span
        >
        <span className="mq-item">Explore a Program <span className="mq-sep">·</span></span
        ><span className="mq-item"
          >Enroll <span className="mq-sep">·</span></span
        ><span className="mq-item"
          >Onboard Your College <span className="mq-sep">·</span></span
        >
        <span className="mq-item">Explore a Program <span className="mq-sep">·</span>
        </span
        ><span className="mq-item"
          >Placement Assistance <span className="mq-sep">·</span></span
        ><span className="mq-item"
          >Find a Job
 <span className="mq-sep">·</span></span
        ><span className="mq-item"
          >Hire Talent
 <span className="mq-sep">·</span></span
        ><span className="mq-item"
          >Explore a Program <span className="mq-sep">·</span></span
        >
      </div>
    </div>
  );
}

export default Marquee;



